module.exports = __webpack_public_path__ + "static/bahamut-humanoid-74dfce1cf758cb2045afd07f10628e7d.png";